<template>
    <transition name="fade">
        <div class="toast" v-show="show" :style="{width: (message.length + 2) + 'em'}">
            {{message}}
        </div>

    </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      message: ""
    };
  }
};
</script>

<style lang="less" scoped>
.toast {
  position: fixed;
  bottom: 15vh;
  left: 50%;
  transform: translateX(-50%);
  padding: 2vw;
  min-width: 30vw;
  font-size: 3.6vw;
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 1vw;
  z-index: 999999;
  box-sizing: border-box;
  opacity: 1;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter {
  opacity: 0;
  transform: translateX(-50%);
}
.fade-leave-to {
  opacity: 0;
  transform: translateX(-50%);
}
</style>


// WEBPACK FOOTER //
// src/components/global/toast/toast.vue